module.exports = __webpack_public_path__ + "img/games-13.e8423472.jpg";